import BaseMixin from './base.mixin'

const mixin = {
  mixins: [
    BaseMixin
  ],
  methods: {
    postPhysicianHeartbeat (payload) {
      return this.requestPost('/core/Physician/Heartbeat', payload)
    }
  }
}

export default mixin
